import { call, put, takeLatest } from "redux-saga/effects";
import { getAllNft, updateConnectedWallet, userLiking } from "../../Domain/api";

import { setProfile } from "./action";
import { GET_OWNED_NFTS, SAVE_CONNECTED_WALLET, SET_LIKED} from "./constants";

export function* doLike({postId, isLiked}) {
    try {
        const mode = isLiked ? 'unlike' : 'like';
        yield call(userLiking, {postId, mode});
    } catch (error) {
        window.location.reload();
    }
}
export function* doGetNfts({address}) {
    try {
        yield call(getAllNft, {address});
    } catch (error) {
        window.location.reload();
    }
}
export function* doSetConnectedWallet({method, wallet, cbSuccess}) {
    try {
        let payload;
        if(method ==='delete'){
            payload = {method};
        }else{
            payload = {wallet};
        }
        const result = yield call(updateConnectedWallet, payload);
        yield put(setProfile(result.client));
        cbSuccess && cbSuccess(wallet);
    } catch (error) {
        window.location.reload();
    }
}
export default function* clientSaga() {
    yield takeLatest(SET_LIKED, doLike);
    yield takeLatest(GET_OWNED_NFTS, doGetNfts);
    yield takeLatest(SAVE_CONNECTED_WALLET, doSetConnectedWallet);
}